import { Modal } from 'react-bootstrap';
import { t } from 'i18next';
import { UserSourceCreateFormDelegator } from '../Forms';
import type { UserSources } from '@api/Entities/User/UserSources';
import type { ModalDefinitions, ModalHostControls } from '@app/UI/Modals/modalRegistry';
import React from 'react';

type UserSourceCreateModalProps = ModalDefinitions['userSourceCreate']['props'] &
  ModalHostControls<'userSourceCreate'>;

export const UserSourceCreateModal = ({ userId, close, resolve }: UserSourceCreateModalProps) => {
  const handleSave = React.useCallback(
    async (userSource: UserSources) => {
      resolve(userSource);
    },
    [resolve]
  );

  return (
    <Modal show onHide={close} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('userSource.createForm.modalTitle')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <UserSourceCreateFormDelegator userId={userId} onSave={handleSave} />
      </Modal.Body>
    </Modal>
  );
};
